import Vue from 'vue'
import Router from 'vue-router'
import firebase from 'firebase/app'
import 'firebase/auth'
import { Loading } from "element-ui";

Vue.use(Router)

const router = new Router({
  mode: 'history',
  scrollBehavior(to, from, savedPosition) {
    return new Promise((resolve, reject) => {
      if (savedPosition) {
        return savedPosition
      } else {
        resolve({ x: 0, y: 0 })
      }
    })
  },
  routes: [
    {
      path: '/',
      name: 'Auth',
      component: require('@/pages/Auth/index').default,
      meta: {
        requiresAuth: false
      }
    },
    {
      path: '/registration',
      name: 'Beta',
      component: require('@/pages/Beta/index').default,
      meta: {
        requiresAuth: false
      }
    },
    {
      path: '/forgot',
      name: 'ForgotPassword',
      component: require('@/pages/Forms/ForgotPassword/index').default,
      meta: {
        requiresAuth: false
      }
    },
    {
      path: '/game',
      name: 'Game',
      component: require('@/pages/Game/index').default,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/dashboard',
      name: 'Dashboard',
      component: () => import('@/pages/Dashboard/index'),
      meta: {
        requiresAuth: true
      }

    },
    {
      path: '/lesson',
      name: 'Lesson',
      component: () => import('@/pages/Lesson/index'),
      props: true,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/test',
      name: 'Test',
      component: () => import('@/pages/Test/index'),
      props: true,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/subscribe',
      name: 'Subscription',
      component: () => import('@/pages/Subscription/index'),
      // props: true,
      meta: {
        requiresAuth: true
      }
    },
    // {
    //   path: '/test',
    //   name: 'Test',
    //   component: () => import('@/pages/Test'),
    //   props: true,
    //   meta: {
    //     requiresAuth: true
    //   }
    // },
    // {
    //   path: '/setting',
    //   name: 'Setting',
    //   component: () => import('@/pages/Setting'),
    //   props: true,
    //   meta: {
    //     requiresAuth: true
    //   }
    // },
    // {
    //   path: '/statistics',
    //   name: 'Statistics',
    //   component: () => import('@/pages/Statistics'),
    //   props: true,
    //   meta: {
    //     requiresAuth: true
    //   }
    // },
    // {
    //   path: '/register',
    //   name: 'Register',
    //   component: () => import('@/pages/Register'),
    //   props: true,
    // }
  ]

})



router.beforeEach((to, from, next) => {


  let currentUser = firebase.auth().currentUser;
  let requiresAuth = to.matched.some(record => record.meta.requiresAuth);
  if (requiresAuth && !currentUser) {
    next('/')
  }
  else if (!requiresAuth && currentUser) {
    next('/dashboard')
  }
  // else if (to.query.category === 'r') {
  //   next('/')
  // }
  else {
    next()
  }
})



router.afterEach(() => {

})


export default router